import { SxProps } from '@mui/material';

export const productDetailsSingleCarouselSX: SxProps = {
	width: '100%',
	'& .swiper': {
		width: '100%',
	},
};

export const productDetailsSingleCarouselImageSX: SxProps = {
	width: '100%',
	height: '100%',
	objectFit: 'contain',
	userSelect: 'none',
};
